import AuthLayout from '@/components/auth-layout';
import ChallengeCard from '@/components/challenge-card';
import Title from '@/components/title';
import { isAuthenticated } from '@/lib/api';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useMissions } from '@/hooks/useMissions';
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/challenges')({
  beforeLoad: async ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: Challenges,
});

function Challenges() {
  const { missions } = useMissions();
  const missionsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      missionsRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }, []);

  const isExpired = (challenge: any) =>
    challenge?.end_date && new Date(challenge.end_date) < new Date();

  const sortedMissions =
    missions?.sort((a, b) => {
      const aExpired = isExpired(a);
      const bExpired = isExpired(b);
      // Expired missions go to the end
      if (aExpired && !bExpired) return 1;
      if (!aExpired && bExpired) return -1;
      return 0;
    }) || [];

  useEffect(() => {
    const element = document.getElementById('missions-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const sumAchievedCredits = () =>
    missions.reduce((sum, mission) => {
      if (mission.partnerMissionStatus === 'completed') {
        const reward = mission.rewardRules?.amount ?? 0;
        return sum + reward;
      }
      return sum;
    }, 0);

  return (
    <AuthLayout>
      <section className="px-4 md:px-0 py-24" ref={missionsRef}>
        <div className="container mx-auto flex flex-col">
          <Title text="Aktuális küldetések" className="text-center" />
          <p className="text-2xl mb-6 text-center">
            Minden teljesített küldetés közelebb visz a jutalmadhoz. Gyűjts
            krediteket, és váltsd be őket élményekre, ajándékokra.
          </p>
          {missions?.length > 0 && (
            <div className="w-full mb-6">
              <p className="text-2xl text-heineken-green font-bold">
                Megszerezve: +{sumAchievedCredits()} kredit
              </p>
            </div>
          )}
        </div>
      </section>
      <section className="px-4 md:px-0 pb-24">
        <div className="container mx-auto">
          {sortedMissions?.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {sortedMissions?.map((mission) => (
                <ChallengeCard key={mission.id} challenge={mission} />
              ))}
            </div>
          ) : (
            <p className="text-center">Nincsenek elérhető küldetések.</p>
          )}
        </div>
      </section>
    </AuthLayout>
  );
}
